import { Children, CSSProperties, FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  // Keep the value on the label's line and let it shrink (for a value that ellipsizes). Default: the value drops under the label when it does not fit.
  noWrap?: boolean;
  style?: CSSProperties;
};

// A "label: value" pair for the request info headers. It lays out like antd's <Space> (each child in its own box,
// 8px apart, centred) but the label is never squeezed by a long value: give the label whiteSpace: 'nowrap', and the
// value either drops under it or, with noWrap, shrinks and ellipsizes.
export const InfoField: FC<Props> = ({ children, noWrap, style }) => {
  const items = Children.toArray(children);

  return (
    <div style={{ display: 'flex', flexWrap: noWrap ? 'nowrap' : 'wrap', alignItems: 'center', columnGap: 8, minWidth: 0, ...style }}>
      {items.map((child, index) => (
        // With noWrap only the last item (the value) may shrink; everything before it keeps its width.
        <div key={index} style={noWrap ? (index === items.length - 1 ? { minWidth: 0 } : { flexShrink: 0 }) : undefined}>
          {child}
        </div>
      ))}
    </div>
  );
};
